import { render } from "./DefaultTemplate.vue?vue&type=template&id=3d5f5eed&scoped=true"
import script from "./DefaultTemplate.vue?vue&type=script&lang=js"
export * from "./DefaultTemplate.vue?vue&type=script&lang=js"

import "./DefaultTemplated.scss?vue&type=style&index=0&id=3d5f5eed&lang=scss&scoped=true"

import exportComponent from "/var/www/briskly/brskl/products/business/app.prod.new/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d5f5eed"]])

export default __exports__